import { Grid } from '@mui/material';
import { ReactNode } from 'react';

import { IBreadCrumbsList, WsBreadCrumbs } from '../WsBreadCrumbs';

type PropsType = {
  breadCrumbsList: IBreadCrumbsList[];
  children?: ReactNode;
  hideCard?: boolean;
};

export const SettingPageBreadCrumbs = ({ breadCrumbsList = [], children }: PropsType) => (
  <Grid container m={1} direction="row" alignItems="center">
    <Grid item xs={12}>
      <WsBreadCrumbs breadCrumbsList={breadCrumbsList} />
    </Grid>
    <Grid item xs={12}>
      {children}
    </Grid>
  </Grid>
);
